import axios from 'axios';
import { useEffect, useState } from 'react';
import { Alert, Button, Modal, Table } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { CONCURSOAPI } from '../../../../../const';
import es from '../../../../../yup-es';
import LinkBtn from '../../../../CompUtils/LinkBtn';
import { finalize, init } from '../../../../GlobalFeedback/feedbackSlice';
import { verPerfilPublicoPuesto } from '../../../Gestion/gestionConcursoSlice';
import './MenuOpcionesPuestoPublicoStyles.css';

export const MenuOpcionesPuestoPublico = ({ idPuesto = '', pathPerfil = '' }) => {
  const dispatch = useDispatch();
  const FILE_TYPES = ['xlsx', 'xls'];
  const [errorMsg, setErrorMsg] = useState('');
  const [perfil, setPerfil] = useState('');
  const [requisitosCargados, setRequisitosCargados] = useState([]);

  function validarTipoArchivoPermitido(value) {
    if (value.name) return FILE_TYPES.includes(value.name.split('.').pop());
    if (value) return FILE_TYPES.includes(value.split('.').pop());
    return false;
  }
  yup.setLocale(es);
  const schemarequisitos = yup.object({
    requisitosFile: yup
      .mixed()
      .test(
        'fileType',
        'Tipo de archivo no soportado',
        (value) => !value || validarTipoArchivoPermitido(value),
      ),
  });
  const initialRequisitos = {
    requisitosFile: {},
  };

  const handleSubmitRequisitos = (formikValues, action) => {
    setErrorMsg('');
    dispatch(init());
    const copy = Object.assign({}, formikValues);
    var formData = new FormData();
    if (copy.requisitosFile) {
      formData.append('file', copy.requisitosFile);
    }
    axios
      .post(`${CONCURSOAPI}/requisitopuesto/loadfile/${idPuesto}`, formData)
      .then((res) => {
        setRequisitosCargados(res.data);
        dispatch(finalize());
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  const [showCargaRequisitosModal, setShowCargaRequisitosModal] = useState(false);
  function handleShowCargaRequisitos() {
    obtenerRequisitosCargados();
    setShowCargaRequisitosModal(!showCargaRequisitosModal);
  }
  const FILE_TYPES_PERFIL = ['pdf', 'PDF'];
  function validarTipoArchivoPerfil(value) {
    if (value.name) return FILE_TYPES_PERFIL.includes(value.name.split('.').pop());
    if (value) return FILE_TYPES_PERFIL.includes(value.split('.').pop());
    return false;
  }
  const schemaperfiles = yup.object({
    perfilesFile: yup
      .mixed()
      .test(
        'fileType',
        'Tipo de archivo no soportado',
        (value) => !value || validarTipoArchivoPerfil(value),
      ),
  });
  const initialPerfiles = {
    perfilesFile: {},
  };
  const handleSubmitPerfiles = (formikValues, action) => {
    setErrorMsg('');
    dispatch(init());
    const copy = Object.assign({}, formikValues);
    var formData = new FormData();
    if (copy.perfilesFile) {
      formData.append('file', copy.perfilesFile);
    }
    axios
      .post(`${CONCURSOAPI}/puesto/file/perfil/${idPuesto}`, formData)
      .then((res) => {
        setPerfil(res.data);
        dispatch(finalize());
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  const [showCargaPerfilesModal, setShowCargaPerfilesModal] = useState(false);
  function handleShowCargaPerfiles() {
    setShowCargaPerfilesModal(!showCargaPerfilesModal);
  }

  function handleClose() {
    setShowCargaPerfilesModal(false);
    setShowCargaRequisitosModal(false);
  }

  const obtenerRequisitosCargados = () => {
    axios
      .get(`${CONCURSOAPI}/concursos-publicados/requisitos/puesto/${idPuesto}`)
      .then((res) => {
        setRequisitosCargados(res.data);
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  useEffect(() => {
    obtenerRequisitosCargados();
    setPerfil(pathPerfil);
  }, []);

  return (
    <>
      <div className="d-grid gap-2">
        <Button
          size="sm"
          style={{ marginLeft: 'auto' }}
          variant="primary"
          onClick={handleShowCargaRequisitos}>
          Requisitos
        </Button>

        <Button
          size="sm"
          style={{ marginLeft: 'auto' }}
          variant="success"
          onClick={handleShowCargaPerfiles}>
          Perfíl
        </Button>
      </div>

      {/* Modal Carga Requisitos */}
      <Modal show={showCargaRequisitosModal} onHide={handleClose} dialogClassName="my-modal">
        <Modal.Header closeButton>
          <Modal.Title>Requisitos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {requisitosCargados.length > 0 && (
            <TableRequisistos requisitos={requisitosCargados}></TableRequisistos>
          )}
          {requisitosCargados.length === 0 && (
            <Alert variant="danger">No hay requisitos cargados</Alert>
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* Modal Carga Perfiles */}
      <Modal show={showCargaPerfilesModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Perfil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {perfil !== '' && perfil != null && (
            <>
              <PerfilPublicoBtn
                className="text-center align-middle"
                idPuesto={idPuesto}></PerfilPublicoBtn>
            </>
          )}
          {perfil === '' ||
            (perfil == null && <Alert variant="danger">No hay perfíl cargado</Alert>)}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};
const PerfilPublicoBtn = (idPuesto = '') => {
  const dispatch = useDispatch();
  const handleViewPerfil = () => {
    dispatch(
      verPerfilPublicoPuesto({
        idPuesto: idPuesto.idPuesto,
      }),
    );
  };
  return (
    <LinkBtn onClick={handleViewPerfil} size="sm" transparent>
      <h5 className="text-center">Archivo Perfil</h5>
    </LinkBtn>
  );
};
const TableRequisistos = ({ requisitos }) => {
  const classes = createUseStyles({
    scrollable: {
      overflow: 'scroll',
      height: '500px',
    },
  })();
  return (
    <div className="container-fluid">
      <div className={classes.scrollable}>
        <Table bordered hover size="sm">
          <thead>
            <tr>
              <th className="text-center align-middle">Nombre</th>
              <th className="text-center align-middle">Descripción</th>
              <th className="text-center align-middle">Requerido</th>
              {/* <th className="text-center align-middle">Excluyente</th> */}
            </tr>
          </thead>

          <tbody>
            {requisitos.map((requisito, i) => {
              return <RowRequisito requisito={requisito} key={i}></RowRequisito>;
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

const RowRequisito = ({ requisito = {}, key = '' }) => {
  return (
    <>
      <tr key={key} className="align-items-center">
        <td className="align-middle">{requisito.nombre}</td>
        <td className="align-middle">{requisito.descripcion}</td>
        <td className="align-middle text-center">
          {requisito.requerido || requisito.excluyente ? 'X' : ''}
        </td>
        {/* <td className="text-center align-middle">{requisito.escluyente ? 'X' : ''}</td> */}
      </tr>
    </>
  );
};
